import React, { Component } from 'react'
import Loginer from '../../controller/Loginer'

export default class Login extends Component {

    state = {
        idName: '',
        password: '',
        message: ''
    }

    componentDidMount() {

        document.getElementById('idName').focus()

    }

    submitFx = (e) => {

        e.preventDefault()
        	
	    Loginer(this.state.idName, this.state.password, res => {

            this.setState({ message: res.message })

        })
	}


    changeFx = (e) => {

        const poo = e.target.id

        this.setState({ [poo] : e.target.value })
    }


    render() {

        return (

            <div className='LoginContainer'>

                <h2>SUBMIT YOUR CODES</h2>

                <br />

                <input type='password' id='idName' value={ this.state.idName } onChange={ this.changeFx } />
                <br />

                <input type='password' id='password' value={ this.state.password } onChange={ this.changeFx } />
                <br /><br />

                <span className='SubmitBtn' onClick={ this.submitFx }>SUBMIT</span>

                <h4>{ this.state.message }</h4>
 
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/etc/Login.js